module.exports = __webpack_public_path__ + "static/img/app_download_remind.88d13c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/app_download_remind.png
// module id = ydiP
// module chunks = 7